<img class="banner-image" src="assets/img/portal-banner.jfif">

<div class="col-md-12 main-view" [class.login-view]="this.oroservice.mode === 0">
  @if (getTitleMapsItems(this.oroservice.mode); as items) {
    <div>
      <div class="title-page-map">
        <a (click)="this.Logout()">
          <mat-icon color="accent">home</mat-icon>
        </a>&nbsp;
        <title-page-map>
          <a (click)="this.Logout()">{{'Startseite.title' | translate}}</a>
          &nbsp;<orange>></orange>&nbsp;
        </title-page-map>
        @if (!items.hasLevel3) {
          <title-page-map>
            {{items.Level2 | translate}}
          </title-page-map>
        }
        @if (items.hasLevel3) {
          <title-page-map>
            <a (click)="this.back()">{{items.Level2 | translate}}</a>
            &nbsp;<orange>></orange>&nbsp;
            {{items.Level3 | translate}}
          </title-page-map>
        }
      </div>
    </div>
  }

  @if (this.oroservice.mode === 0) {
    <div>
      <h2 class="page-title">{{'Login.Willkommen' | translate}}</h2>
      <mat-divider></mat-divider>
      <div class="login-layout">
        <div class="login-info">
          <p>{{'Login.Info' | translate}}</p>
          <div class="outline-orange login-contact">
            {{'Login.Contact' | translate}}
            <div class="login-phone">
              <mat-icon aria-hidden="true">call</mat-icon>
              <span>032 344 39 69</span>
            </div>
          </div>
        </div>
        <div class="login-form">
          <strong class="login-prompt">{{'Login.Anmeldeaufforderung' | translate}}</strong>
          <mat-form-field appearance="fill" class="login-form-field" floatLabel="always">
            <mat-label>{{'Startseite.Token' | translate}}</mat-label>
            <input matInput [(ngModel)]="this.oroservice.Token" autofocus autocomplete="off"
              class="login-token" (keyup.enter)="next()">
          </mat-form-field>
          <button mat-flat-button color="primary" (click)="next()" class="button-standard">
            {{'Login.Anmelden' | translate}}
          </button>
        </div>
      </div>
    </div>
  }

      @if (this.oroservice.mode == 1) {
        <div>
          <div class="dossierinfos col-md-12 no-padding">
            <h2 class="page-title">{{'Dossier.Info' | translate}}</h2>
            <mat-divider></mat-divider>
            <mat-table [dataSource]="dossierDatasource" class="mat-elevation-z2" style="margin-bottom: 24px;">
              <!-- Datum Column -->
              <ng-container matColumnDef="Key">
                <mat-header-cell *matHeaderCellDef>KEY</mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.Key | translate}} </mat-cell>
              </ng-container>
              <!-- Betrag Column -->
              <ng-container matColumnDef="Value">
                <mat-header-cell *matHeaderCellDef>VALUE </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.Value}}</mat-cell>
              </ng-container>
              <mat-header-row *matHeaderRowDef="dossierDisplayedColumns" style="display: none;"></mat-header-row>
              <mat-row *matRowDef="let row; columns: dossierDisplayedColumns;"></mat-row>
            </mat-table>
          </div>
          @if (this.dossierinfo?.Restschuld > 0 && !this.isEmptyObject(this.dossierinfo?.Ratenplan)) {
            <div
              class="ibox float-e-margins m-b">
              <h2 class="page-title">{{'Ratenplan.Title' | translate}}</h2>
              <mat-divider></mat-divider>
              <mat-table [dataSource]="this.dossierinfo?.Ratenplan?.Raten" class="mat-elevation-z2"
                style="margin-bottom: 24px;">
                <!-- Datum Column -->
                <ng-container matColumnDef="Datum">
                  <mat-header-cell *matHeaderCellDef>
                    <mat-icon>event</mat-icon>&nbsp;&nbsp;{{'Ratenplan.Fälligkeit' | translate}}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.Datum}} </mat-cell>
                </ng-container>
                <!-- Betrag Column -->
                <ng-container matColumnDef="Betrag">
                  <mat-header-cell *matHeaderCellDef>
                    <mat-icon>payments</mat-icon>&nbsp;&nbsp;{{'Ratenplan.Betrag' | translate}}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element"> CHF&nbsp;{{element.Betrag | number: '1.2-2'}}</mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="ratenplanDisplayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: ratenplanDisplayedColumns;"></mat-row>
              </mat-table>
            </div>
          }
          <div class="row col-md-12 no-padding row-button">
            <div class="col-md-6 col-button">
              @if (this.dossierinfo.CanCreateRatenplan) {
                <button mat-flat-button color="primary" class="button-standard"
                  (click)="onFilterChangeRatenplan($event)">
                  {{'Startseite.RatenBezahlen' | translate}}
                </button>
              }
            </div>
            <div class="col-md-6 col-button">
              @if (!this.dossierinfo.Abgerechnet && this.dossierinfo?.Restschuld > 0) {
                <button mat-flat-button color="primary" class="button-standard"
                  (click)="onFilterChangeDirektzahlung($event)"
                  >
                  {{'Startseite.BereitsBezahlt' | translate}}
                </button>
              }
            </div>
            @if (this.dossierinfo.CanRequestUeberzahlung && this.dossierinfo?.Restschuld < -10) {
              <button mat-flat-button color="primary" class="button-standard"
                (click)="onFilterChangeUeberzahlung($event)">
                {{'Startseite.Ueberzahlung' | translate}}
              </button>
            }
          </div>
        </div>
      }

      <!-- ************* -->
      <!-- * RATENPLAN * -->
      <!-- ************* -->
      @if (this.oroservice.mode ==2) {
        <div class="col-md-12 no-padding">
          @if (chooseRatenplan) {
            <div>
              <div class="col-md-12 no-padding">
                <span class="label label-warning pull-right"></span>
                <h2 class="page-title">{{'Startseite.RatenBezahlen' | translate}}</h2>
                <mat-divider></mat-divider>
              </div>
              {{'Ratenplan.Info'| translate}}
              <BR><BR>
              <div class="col-md-12 row no-padding">
                <label class="col-md-3 control-label labelclass no-padding">{{'Ratenplan.Gesamtbetrag'| translate}}
                </label>
                <div class="col-md-3 no-padding">
                  @if (isValid) {
                    <mat-form-field appearance="fill" class="input-valid transparent-field">
                      <input matInput style="margin: 0px;" readonly="true"
                        [ngModel]="Ratenplan.Gesamtbetrag | number: '1.2-2'"
                        placeholder="{{'Ratenplan.Gesamtbetrag' | translate}}"
                        matTooltip="{{'Ratenplan.InfoGesamtbetrag' | translate}}">
                        <span matPrefix>CHF&nbsp;</span>
                      </mat-form-field>
                    }
                  </div>
                </div>
                <div class="col-md-12 row no-padding">
                  <label class="col-md-3 control-label labelclass no-padding">{{'Ratenplan.PayTax'| translate}}
                  </label>
                  <div class="col-md-3 no-padding">
                    @if (isValid) {
                      <mat-form-field appearance="fill" class="input-valid transparent-field">
                        <input matInput readonly="true" [ngModel]="Ratenplan.Zinsen | number: '1.2-2'"
                          placeholder="{{'Ratenplan.PayTax' | translate}}"
                          matTooltip="{{'Ratenplan.PayTax' | translate}}">
                          <span matPrefix>CHF&nbsp;</span>
                        </mat-form-field>
                      }
                    </div>
                  </div>
                  <div class="col-md-12 row no-padding">
                    <label class="col-lg-3 col-md-3 control-label labelclass no-padding">{{'Ratenplan.MonatlicheRate'|
                      translate}}
                    </label>
                    <div class="col-lg-3 col-md-3 no-padding">
                      @if (isValid) {
                        <mat-form-field appearance="fill" class="input-valid">
                          <input matInput style="margin: 0px" Min="30"
                            [ngModel]="Ratenplan.MonatlicheRate | number: '1.2-2'" [ngModelOptions]="{updateOn:'blur'}"
                            [readonly]="Ratenplan.Vereinbart" (ngModelChange)="changeratetext($event)" type="number"
                            placeholder="{{'Ratenplan.MonatlicheRate' | translate}}">
                            <span matPrefix>CHF&nbsp;</span>
                          </mat-form-field>
                        }
                      </div>
                    </div>
                    <div class="col-md-12 row no-padding">
                      <label class="col-lg-3 col-md-3 control-label labelclass no-padding">{{'Ratenplan.AnzahlRaten'|
                        translate}}
                      </label>
                      <div class="col-lg-3 col-md-3 no-padding">
                        @if (isValid) {
                          <mat-form-field appearance="fill" class="input-valid">
                            <input matInput [(ngModel)]="Ratenplan.AnzahlRaten" style="margin: 0px"
                              [readonly]="Ratenplan.Vereinbart" (change)="changeanzahltext()" type="number"
                              placeholder="{{'Ratenplan.AnzahlRaten' | translate}}">
                            </mat-form-field>
                          }
                        </div>
                      </div>
                      <div class="col-md-12 row no-padding">
                        <label class="col-lg-3 col-md-3 labelclass no-padding">{{'Ratenplan.Datenliste'|translate}}
                        </label>
                        <div class="col-lg-3 col-md-3 no-padding">
                          @if (isValid && Ratenplan && Ratenplan.Datenliste) {
                            <mat-form-field appearance="fill" style="width: 100%; padding-right: 12px;"
                              >
                              <mat-select [disabled]="Ratenplan.Vereinbart" [(ngModel)]="Ratenplan.ErsteRate"
                                [readonly]="Ratenplan.Vereinbart" matTooltip="{{'Ratenplan.InfoErsteRate' | translate}}">
                                <mat-option [value]="Ratenplan.Datenliste[0]">{{Ratenplan.Datenliste[0]}}</mat-option>
                                <mat-option [value]="Ratenplan.Datenliste[1]">{{Ratenplan.Datenliste[1]}}</mat-option>
                              </mat-select>
                            </mat-form-field>
                          }
                        </div>
                      </div>
                      <div class="row col-md-12 no-padding row-button">
                        <div class="col-md-6 col-button">
                          <button mat-flat-button color="primary" class="button-standard" (click)="Calculate()">
                            <div class="vertical-center">
                              <mat-icon>bar_chart</mat-icon>&nbsp;&nbsp;{{'Startseite.RatenplanBerechnen' | translate}}
                            </div>
                          </button>
                        </div>
                      </div>
                      @if (Ratenplan && Ratenplan.Raten) {
                        <div class="col-md-12 row no-padding">
                          <mat-table [dataSource]="Ratenplan.Raten" class="mat-elevation-z2 no-padding"
                            style="width:100%; margin: 24px 0px 24px 0px;">
                            <!-- Datum Column -->
                            <ng-container matColumnDef="Datum">
                              <mat-header-cell *matHeaderCellDef>
                                <mat-icon>event</mat-icon>&nbsp;&nbsp;{{'Ratenplan.Fälligkeit' | translate}}
                              </mat-header-cell>
                              <mat-cell *matCellDef="let element"> {{element.Datum}} </mat-cell>
                            </ng-container>
                            <!-- Betrag Column -->
                            <ng-container matColumnDef="Betrag">
                              <mat-header-cell *matHeaderCellDef>
                                <mat-icon>payments</mat-icon>&nbsp;&nbsp;{{'Ratenplan.Betrag' | translate}}
                              </mat-header-cell>
                              <mat-cell *matCellDef="let element"> CHF&nbsp;{{element.Betrag | number: '1.2-2'}}</mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="ratenplanDisplayedColumns"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: ratenplanDisplayedColumns;"></mat-row>
                          </mat-table>
                        </div>
                      }
                    </div>
                  }
                  <!-- ***************** -->
                  <!-- * DIREKTZAHLUNG * -->
                  <!-- ***************** -->
                  @if (chooseDirektzahlung) {
                    <div>
                      <div class="col-md-12 no-padding">
                        <h2 class="page-title">{{'Dossier.Direktzahlung' | translate}}</h2>
                        <mat-divider></mat-divider>
                      </div>
                      <div class="row" style="margin: 0px;">
                        @for (ford of this.Direktzahlung?.Forderungen; track ford; let i = $index) {
                          <div class="col-md-12 row"
                            style="padding:0px; margin:0px">
                            <div class="col-md-4 col-xs-9 dz-fields">
                              <mat-form-field appearance="fill" class="login-form-field" style="width: 100%">
                                <mat-label>{{'Rechnungsnummer' | translate}}</mat-label>
                                <input matInput [(ngModel)]="ford.Referenz" style="margin: 0px" readonly="true">
                                <button mat-flat-button color="primary" matPrefix (click)="DirektZahlungAdd(ford, i)" class="icon-button"
                                  matTooltip="{{'Dossier.PlusTooltip' | translate}}">
                                  <mat-icon style="padding:0px; margin: 0px; ">add</mat-icon>
                                </button>
                                @if (this.Direktzahlung.Forderungen.length > 1) {
                                  <button mat-icon-button matSuffix
                                    aria-label="Remove" (click)="DirektZahlungRemove(i)">
                                    <mat-icon style="color:darkred">close</mat-icon>
                                  </button>
                                }
                              </mat-form-field>
                            </div>
                            <div class="col-md-4 col-xs-9 dz-fields">
                              <mat-form-field appearance="fill" class="custom-chf-prefix" style="width: 100%">
                                <mat-label>{{'Betrag' | translate}}</mat-label>
                                <input matInput [(ngModel)]="ford.Betrag" required
                                  pattern="[(0-9)|']+([\.,][0-9]{1,2})?" type="number" autocomplete='off'>
                                  <span matTextPrefix>CHF&nbsp;</span>
                                </mat-form-field>
                              </div>
                              <div class="col-md-4 col-xs-9 dz-fields">
                                <mat-form-field appearance="fill" style="width: 100%">
                                  <mat-label>{{'Startseite.Zahldatum' | translate}}</mat-label>
                                  <input matInput [matDatepicker]="picker"
                                    [ngModel]="ford.Zahldatum"
                                    (ngModelChange)="onDateChange($event, ford)"
                                    [matDatepickerFormat]="'dd.MM.yyyy'"
                                    required autocomplete='off'>
                                    <mat-datepicker-toggle matSuffix [for]="picker" tabindex="-1"></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                  </mat-form-field>
                                </div>
                                @if (checkDirektzahlungsDatumZukunft(ford.Zahldatum)) {
                                  <div class="row no-padding"
                                    style="text-align: right">
                                    <mat-error style="justify-content: right;">{{'DatumZukunft' | translate}}</mat-error>
                                  </div>
                                }
                                @if (checkDirektzahlungsVorEroefffnung(ford)) {
                                  <div class="row no-padding">
                                    <mat-error>{{ "Direktzahlung.ErrorVorEroeffnung" | translate: { GrundForderung:
                                    ford.Grundforderung | number : '1.2-2' } }}</mat-error>
                                  </div>
                                }
                              </div>
                            }
                            <div class="col-md-12 no-padding">
                              <orange>*</orange>&nbsp;{{'Pflichtangaben' | translate}}
                            </div>
                            <div class="col-md-12 no-padding">
                              <div class="outline-blue" style="margin-bottom: 19px;">
                                <div class="row no-padding">
                                  <div class="rmpm dropzone" style="width:260px" appDragDrop
                                    (files)="fileservice.filesDropped($event)">
                                    <div class="text-wrapper">
                                      <div class="centered">
                                        <mat-icon
                                        style="font-size: 64px; width:64px; height: 64px; opacity: 0.2;">publish</mat-icon>
                                        <BR>
                                        {{'Drag' | translate}}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col">
                                    <button mat-button matSuffix (click)="fileMultiInput.click()">
                                      <mat-icon>attach_file</mat-icon> {{'Dateiauswaehlen' | translate}}
                                    </button>
                                    @if (this.fileservice.files.length > 3) {
                                      <button mat-button matSuffix
                                        (click)="fileservice.removeAllFiles()">
                                        <mat-icon>delete</mat-icon> {{'Alle löschen' | translate}}
                                      </button>
                                    }
                                    <input hidden (change)="fileservice.handleMultiFileInput($event.target.files)"
                                      #fileMultiInput type="file" accept=".pdf,.jpg,.jpeg" id="file">
                                      <div class="row no-padding">
                                        <mat-list>
                                          @for (file of fileservice.files; track file) {
                                            <mat-list-item
                                              style="height:36px; font-size: 14px;">
                                              <mat-icon>picture_as_pdf</mat-icon>&nbsp;
                                              {{fileservice.getFileInfo(file)}}&nbsp;
                                              <button mat-icon-button color="accent" matSuffix
                                                (click)="fileservice.removeFile(file)" style="margin:0px">
                                                <mat-icon>delete</mat-icon>
                                              </button>
                                            </mat-list-item>
                                          }
                                        </mat-list>
                                      </div>
                                      @if (fileservice.isFileTooBig) {
                                        <div class="row no-padding">
                                          <mat-error>{{'ErrorSizeFormat' | translate}}</mat-error>
                                        </div>
                                      }
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                        @if (chooseUeberzahlung) {
                          <div class="col-md-12 no-padding">
                            <div class="ibox-title">
                              <span class="label label-warning pull-right"></span>
                              <h2 class="page-title">{{'Dossier.Direktzahlung' | translate}}</h2>
                              <mat-divider></mat-divider>
                            </div>
                            <div class="col-md-12 row">
                              <div class="col-md-12 row">
                                <div class="col-sm-7">
                                  <mat-form-field appearance="fill" style="width: 100%; padding-right: 12px;">
                                    <input matInput [(ngModel)]="this.zahlung.Kontoinhaber" style="margin: 0px" required
                                      placeholder="{{'Ueberzahlung.Kontoinhaber' | translate}}">
                                    </mat-form-field>
                                  </div>
                                  <div class="col-sm-5 small labelclass">
                                    {{'Ueberzahlung.InfoKontoinhaber' | translate}}
                                  </div>
                                </div>
                                <div class="col-md-12 row">
                                  <div class="col-sm-7">
                                    <mat-form-field appearance="fill" style="width: 100%; padding-right: 12px;">
                                      <input matInput [(ngModel)]="this.zahlung.IBAN" style="margin: 0px" required
                                        placeholder="{{'IBAN' | translate}}">
                                      </mat-form-field>
                                    </div>
                                    <div class="col-sm-5 small labelclass">
                                      {{'Ueberzahlung.IBAN' | translate}}
                                    </div>
                                  </div>
                                  <div class="col-md-12 row">
                                    <div class="col-sm-7">
                                      <mat-form-field appearance="fill" style="width: 100%; padding-right: 12px;">
                                        <input matInput [(ngModel)]="this.zahlung.Bank" style="margin: 0px" required
                                          placeholder="{{'Bank' | translate}}">
                                        </mat-form-field>
                                      </div>
                                      <div class="col-sm-5 small labelclass">
                                        {{'Ueberzahlung.Bank' | translate}}
                                      </div>
                                    </div>
                                    <div class="col-md-12 row">
                                      <div class="col-sm-7">
                                        <mat-form-field appearance="fill" style="width: 100%; padding-right: 12px;">
                                          <input matInput [(ngModel)]="this.dossierinfo.Ueberzahlungsbetrag" style="margin: 0px"
                                            placeholder="{{'Betrag' | translate}}">
                                            <span matPrefix>CHF&nbsp;</span>
                                          </mat-form-field>
                                        </div>
                                        <div class="col-sm-5 small labelclass">
                                          {{'Ueberzahlung.InfoBetrag' | translate}}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                }
                              </div>
                            }

                            <div class="row col-md-12 no-padding row-button">
                              <div class="col-md-6 col-button">
                                @if (this.oroservice.mode != 0 && this.oroservice.mode !=1) {
                                  <button mat-flat-button color="primary"
                                    (click)="back()" class="button-standard">
                                    <div class="vertical-center">
                                      <mat-icon>arrow_back</mat-icon>&nbsp;&nbsp;{{'Startseite.VorherigerSchritt' | translate}}
                                    </div>
                                  </button>
                                }
                              </div>
                              <div class="col-md-6 col-button">
                                @if ((this.oroservice.mode ==2 && this.chooseDirektzahlung ) || (this.oroservice.mode ==2 && this.chooseUeberzahlung ) || (this.oroservice.mode == 2 && this.chooseRatenplan && (  Ratenplan?.IsValid || Ratenplan?.Vereinbart))) {
                                  <button mat-flat-button color="primary" class="button-standard" (click)="next()"
                                    [disabled]="isUpdating || !this.CanSubmit()"
                                    >
                                    <div class="vertical-center">
                                      {{this.oroservice.mode ==0 ? ('Startseite.Anmelden' | translate):
                                      (this.oroservice.mode==1 ? ('Startseite.Waehlen' | translate) :
                                      this.chooseDirektzahlung? ('Startseite.WaehlenZahlung' | translate) :
                                      this.chooseRatenplan? ('Startseite.WaehlenRatenplan' | translate) : ('Startseite.UeberzahlungMelden'
                                      | translate)) }}
                                      &nbsp;&nbsp;<mat-icon>arrow_forward</mat-icon>
                                      @if (isUpdating) {
                                        <mat-icon style="margin-left: 8px;"><mat-spinner
                                        diameter="20"></mat-spinner></mat-icon>
                                      }
                                    </div>
                                  </button>
                                }
                              </div>
                            </div>
                          </div>
